<script setup lang="ts">
import pack from '../../package.json'
import { cilMoon, cilSun } from '@coreui/icons'
import CountryFlag from 'vue-country-flag-next'

import { useI18n } from 'vue-i18n'

const version = ref(pack.version)

const { locale, availableLocales } = useI18n()

const themeStore = useThemeStore()
const { theme } = storeToRefs(themeStore)

const changeLocale = lang => {
  locale.value = String(lang)
  localStorage.setItem('languageSetup', String(lang))
}

const computedLocale = computed(() => {
  switch (locale.value) {
    case 'en':
      return 'gb'
    case 'ca':
      return 'es-ca'
    case 'eu':
      return 'es-eu'
    default:
      return locale.value
  }
})

const getFlag = lang => {
  switch (lang) {
    case 'en':
      return 'gb'
    case 'ca':
      return 'es-ca'
    case 'eu':
      return 'es-eu'
    default:
      return lang
  }
}

const orderedLocales = computed(() => {
  const order = ['es', 'en', 'ca', 'eu']
  return order.filter(lang => availableLocales.includes(lang))
})
</script>

<template>
  <CFooter>
    <div class="d-flex justify-content-start align-items-start">
      <CDropdown>
        <CDropdownToggle color="link" size="sm">
          <country-flag :country="computedLocale" v-if="computedLocale !== 'es-eu'" />
          <span v-else>
            <img src="/ikurri.png" width="26px" height="20px" />
          </span>
        </CDropdownToggle>
        <CDropdownMenu>
          <CDropdownItem v-for="lang in orderedLocales" :key="lang" href="#" @click="changeLocale(lang)">
            <country-flag :country="getFlag(lang)" size="big" v-if="lang !== 'eu'" />
            <span v-else class="flag normal-flag">
              <img src="/ikurri.png" />
            </span>
          </CDropdownItem>
        </CDropdownMenu>
      </CDropdown>

      <CTooltip v-if="theme === 'dark'" content="Light" placement="top">
        <template #toggler="{ id, on }">
          <a @click="themeStore.toggleTheme" href="#" :aria-describedby="id" v-on="on" style="padding-top: 8px">
            <CIcon :icon="cilSun" />
          </a>
        </template>
      </CTooltip>
      <CTooltip v-if="theme === 'light'" content="Dark" placement="top">
        <template #toggler="{ id, on }">
          <a
            @click="themeStore.toggleTheme"
            href="#"
            :aria-describedby="id"
            v-on="on"
            color="light"
            style="padding-top: 8px"
          >
            <CIcon :icon="cilMoon" />
          </a>
        </template>
      </CTooltip>
      <div class="cookie-counter pt-2"></div>
    </div>

    <div>
      <span class="me-3" target="_blank">
        <strong>Events Manager</strong>
        {{ version }}
      </span>
      <a href="https://bmotionav.com" class="me-3" target="_blank">
        &copy;{{ new Date().getFullYear() }} Bmotion AV S.L.
      </a>
    </div>
  </CFooter>
</template>
